import { transformCoreFormInputToCoreExerciseInput, transformCoreExerciseToFormInput } from 'modules/exercises/utils';
import { MultipleChoiceExerciseInput } from '../types/form';
import { CreateMultipleChoiceExerciseInput, MultipleChoiceExercise } from '../types';

export function transformFormInputToMutationInput(formInput: MultipleChoiceExerciseInput): CreateMultipleChoiceExerciseInput {
  const { questions } = formInput;

  const coreData = transformCoreFormInputToCoreExerciseInput(formInput);

  return {
    ...coreData,
    questions,
  };
}

export function transformMultipleChoiceExerciseToFormInput(exercise: MultipleChoiceExercise): MultipleChoiceExerciseInput {
  const { questions } = exercise;
  const coreData = transformCoreExerciseToFormInput(exercise);
  return {
    ...coreData,
    questions,
  };
}
